var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14062 5.96875C0.964844 6.14453 0.964844 6.39062 1.14062 6.56641L6.30859 11.7695C6.44922 11.9453 6.73047 11.9453 6.90625 11.7695L7.57422 11.0664C7.75 10.8906 7.75 10.6445 7.57422 10.4688L3.42578 6.25L7.57422 2.06641C7.75 1.89062 7.75 1.60938 7.57422 1.46875L6.90625 0.765625C6.73047 0.589844 6.44922 0.589844 6.30859 0.765625L1.14062 5.96875Z",
    fill: "#007040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.c495b46b4a52ad6372b8c727a3c17841.svg";
export { ForwardRef as ReactComponent };